import React from "react";
import * as Animate from "react-reveal";
import ButtonLink from "../../../components/elements/ButtonLink";

const ExpertSection = () => {
  return (
    <section className="pt-20 lg:pt-24 pb-24 lg:pb-28 individual-expert-section">
      <div className="container mx-auto px-4">
        <div className="flex flex-row flex-wrap justify-between items-center">
          <div className="w-full lg:w-6/12 xl:w-5/12">
            <Animate.Fade bottom>
              <h2 className="text-primary text-3xl lg:text-4xl xl:text-5xl xl:leading-tight font-mono font-semibold w-full lg:w-11/12">
                Are you a knowledge expert?
              </h2>

              <p className="mt-8 text-base lg:text-lg xl:text-xl lg:leading-7 w-full lg:w-10/12">
                Join Utiva as a trainer, earn a living while building the next
                tech talent
              </p>

              <div className="mt-8 lg:mt-12">
                <ButtonLink title={"Become A Trainer"} url="/be-a-trainer" />
              </div>
            </Animate.Fade>
          </div>

          <div className="w-full lg:w-6/12 relative mt-6 lg:mt-0">
            <div className="w-full h-56 lg:h-60 bg-secondary absolute top-1 left-1 lg:top-0 lg:left-2"></div>
            <div className="bg-darkgreen px-6 lg:px-10 py-10 relative -left-2 lg:-left-3 lg:-top-4">
              <p className="text-white font-semibold font-mono text-base md:text-lg lg:text-xl">
                How to become a trainer
              </p>

              <ul className="ml-4 mt-4 lg:pr-6 list-outside list-disc text-white text-sm md:text-sm-15 lg:text-base space-y-4">
                <li>
                  Review the Utiva Learning Structure and Delivery Model to
                  ensure we fit your expectation
                </li>
                <li>
                  Send in your details and apply to be a coach through a simple
                  application
                </li>
              </ul>
            </div>

            <div className="mt-10 lg:mt-6">
              {/* <p className="font-mono text-primary text-base lg:text-lg">
                Some of our seasoned trainers
              </p> */}

              {/* <div className="mt-6 lg:mt-8 grid grid-cols-2 gap-6 md:grid-cols-4">
                {data?.map((datum) => (
                  <Card key={datum?.id} datum={datum} />
                ))}
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExpertSection;
